export default __webpack_public_path__ + "static/media/poi-passport.70c39fd4.png";